export type AdvertiserDisclosurePosition =
  | 'top-left'
  | 'top-right'
  | 'top-center'
  | 'bottom-left'
  | 'bottom-right'
  | 'bottom-center';

export const getPositionProps = (position: AdvertiserDisclosurePosition) => {
  let isTopPosition = false;
  let isLeftPosition = false;
  let isCenterPosition = false;
  let horizontalAlignment: 'left' | 'center' | 'right' = 'right';

  switch (position) {
    case 'top-left':
      isTopPosition = true;
      isLeftPosition = true;
      horizontalAlignment = 'left';
      break;
    case 'top-center':
      isTopPosition = true;
      isCenterPosition = true;
      horizontalAlignment = 'center';
      break;
    case 'top-right':
      isTopPosition = true;
      break;
    case 'bottom-left':
      isLeftPosition = true;
      horizontalAlignment = 'left';
      break;
    case 'bottom-center':
      isCenterPosition = true;
      horizontalAlignment = 'center';
      break;
  }

  return {
    isTopPosition,
    isLeftPosition,
    isCenterPosition,
    horizontalAlignment,
  };
};

export const getTailStyles = (position: AdvertiserDisclosurePosition) => {
  const { isTopPosition, isLeftPosition, isCenterPosition } = getPositionProps(position);

  // ::before renders the border-colored triangle, ::after renders the white-filled triangle on top.
  const tailBorderOffset = isCenterPosition
    ? { left: '50%', transform: 'translateX(-50%)' }
    : isLeftPosition
      ? { left: 'calc(var(--ad-tail-offset) - var(--ad-border-width))' }
      : { right: 'calc(var(--ad-tail-offset) - var(--ad-border-width))' };
  const tailContentOffset = isCenterPosition
    ? { left: '50%', transform: 'translateX(-50%)' }
    : isLeftPosition
      ? { left: 'var(--ad-tail-offset)' }
      : { right: 'var(--ad-tail-offset)' };
  const commonTailStyles = {
    content: '""',
    position: 'absolute',
  };

  const topTail = {
    '&::before': {
      ...commonTailStyles,
      ...tailBorderOffset,
      bottom: 'calc(var(--ad-tail-size) * -1)',
      borderLeft: 'calc(var(--ad-tail-size) + var(--ad-border-width)) solid transparent',
      borderRight: 'calc(var(--ad-tail-size) + var(--ad-border-width)) solid transparent',
      borderTop: 'var(--ad-tail-size) solid',
      borderTopColor: 'neutral.light',
      borderBottom: 'none',
    },
    '&::after': {
      ...commonTailStyles,
      ...tailContentOffset,
      bottom: 'calc(var(--ad-tail-size) * -1 + var(--ad-border-width))',
      borderLeft: 'var(--ad-tail-size) solid transparent',
      borderRight: 'var(--ad-tail-size) solid transparent',
      borderTop: 'var(--ad-tail-size) solid',
      borderTopColor: 'white',
      borderBottom: 'none',
    },
  };
  const bottomTail = {
    '&::before': {
      ...commonTailStyles,
      ...tailBorderOffset,
      top: 'calc(var(--ad-tail-size) * -1)',
      borderLeft: 'calc(var(--ad-tail-size) + var(--ad-border-width)) solid transparent',
      borderRight: 'calc(var(--ad-tail-size) + var(--ad-border-width)) solid transparent',
      borderBottom: 'var(--ad-tail-size) solid',
      borderBottomColor: 'neutral.light',
      borderTop: 'none',
    },
    '&::after': {
      ...commonTailStyles,
      ...tailContentOffset,
      top: 'calc(var(--ad-tail-size) * -1 + var(--ad-border-width))',
      borderLeft: 'var(--ad-tail-size) solid transparent',
      borderRight: 'var(--ad-tail-size) solid transparent',
      borderBottom: 'var(--ad-tail-size) solid',
      borderBottomColor: 'white',
      borderTop: 'none',
    },
  };

  return {
    '--ad-tail-size': '9px',
    '--ad-tail-offset': '17px',
    '--ad-border-width': '1px',
    ...(isTopPosition ? topTail : bottomTail),
  };
};
